var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookmarkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 20.9084V16.7484C25.5 13.1734 25.5 11.3875 24.4017 10.2767C23.3033 9.16669 21.535 9.16669 18 9.16669C14.465 9.16669 12.6967 9.16669 11.5983 10.2767C10.5 11.3867 10.5 13.175 10.5 16.7484V20.9092C10.5 23.4892 10.5 24.78 11.1117 25.3434C11.4033 25.6125 11.7717 25.7817 12.1642 25.8267C12.9867 25.9209 13.9475 25.0709 15.8683 23.3717C16.7183 22.6209 17.1425 22.245 17.6333 22.1467C17.875 22.0967 18.125 22.0967 18.3667 22.1467C18.8583 22.245 19.2825 22.6209 20.1317 23.3717C22.0525 25.0709 23.0133 25.9209 23.8358 25.8259C24.2275 25.7817 24.5967 25.6125 24.8883 25.3434C25.5 24.78 25.5 23.4892 25.5 20.9084Z",
    stroke: "#00ADEF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M20.5 12.5H15.5",
    stroke: "#00ADEF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkIcon);
export default __webpack_public_path__ + "static/media/bookmarkIcon.99686f36791e19f7a258e833cce3cd8d.svg";
export { ForwardRef as ReactComponent };